// Pure decision logic for the DM/intro-chat reminder bell digest
// (Notifications.js). Extracted so the branching that decides how to
// dismiss a digest row, and where the intro-chat digest navigates, can be
// unit tested without pulling in a component-testing framework.

/**
 * Args for updateInAppDeleteStatusOnClick when the recipient dismisses a
 * DM/intro-chat reminder bell row. A digest (unreadCount > 1) is one
 * aggregated row backed by N underlying claim rows in the DB - there is no
 * single NotificationId to delete by, so it must dismiss every row of that
 * SubjectType for the recipient instead (deleteType !== 1, notificationId
 * null, with subjectType set so the API/hook scope the delete to just this
 * type rather than the global "Clear All" wipe).
 */
export function getReminderDismissArgs({
  notificationId,
  subjectType,
  unreadCount = 1,
}) {
  const isPlural = unreadCount > 1;
  return isPlural
    ? [null, subjectType, true, 2]
    : [notificationId, subjectType, true, 1];
}

/**
 * Whether the intro-chat reminder digest should deep-link straight to one
 * introduction, or fall back to the all-introductions tab. True only when
 * there is exactly one unread introduction AND its slug is known - a
 * plural digest never has one introduction to point at, and a missing slug
 * (e.g. the want-ad was deleted) must fall back rather than build a broken
 * link. Previously a missing slug made the whole row (and its delete
 * button) render as null, leaving an undismissable bell entry.
 */
export function shouldDeepLinkToIntroduction({ unreadCount = 1, slug }) {
  return unreadCount <= 1 && Boolean(slug);
}
